let Backbone = window.Backbone;
let $ = jQuery;
let _ = window._;

let Filter = Backbone.View.extend({
  tagName: 'span',
  template: _.template(`<%= name %>`),
  events: {
    'click': 'onChange'
  },

  initialize: function() {
    this.render();
  },

  render: function() {
    if(this.model.get('selected')) {
      this.$el.addClass('is-selected');
    }

    this.$el.html(this.template(this.model.toJSON()));
    return this.$el;
  },

  onChange: function() {
    window.sfscpaVent.trigger( this.model.get('selected') ? 'delete-filter' : 'add-filter', this.model);
  },
});

export default Backbone.View.extend({
  tagName: 'span',
  className: 'userContent__filter',

  initialize: function(options) {
    this.taxonomy = options.taxonomy;
    this.render();

    this.collection.on('all', this.render, this);
  },

  render: function() {
    this.$el.html(`<span class="userContent__filterTaxonomy">-- ${this.taxonomy.niceName} --</span>`);

    let filterDropdown = $('<span class="userContent__filtersDropdown"/>');

    this.collection.each((filter) => {
      filter.set('taxonomy', this.taxonomy);

      filterDropdown.append(new Filter({ model: filter }).$el);

      if(filter.get('selected')) {
        window.sfscpaVent.trigger('add-filter', filter);
      }
    });

    this.$el.append(filterDropdown);
    return this;
  },
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/filters/Filter.view.js